<template>
  <div class="my-coupons-page">
    <Tabs
      :options="tabsOptions"
      :cur-tab="curTab"
      @tabClick="handleTabClick"
    />

    <van-pull-refresh
      v-model="showPullRefreshLoading"
      @refresh="toFindPurchasedRight"
    >
      <div class="coupons">
        <CouponCard
          class="coupon"
          v-for="(item, index) in cardList"
          :key="index"
          :value="item"
          :disabled="isDisabled"
        />
        <div
          v-if="!cardList.length"
          class="coupons-blank"
        >
          <Blank text="暂无优惠券" />
          <div
            v-if="curTab === 'waitUseList'"
            class="buy-coupon-btn"
            @click="toCharingCenterPage"
          >
            购买充电券
          </div>
        </div>
        <div
          v-if="$parent.showBottomNavBar"
          class="h-bottom-nav"
        />
      </div>
    </van-pull-refresh>

    <CustomerServiceBtn />
  </div>
</template>

<script>
import Tabs from './Tabs.vue';
import CouponCard from './CouponCard.vue';
import Blank from './Blank.vue';
import { findPurchasedRight } from '@/common/api.js';
import CustomerServiceBtn from './CustomerServiceBtn.vue';

class CreateInfo {
  waitUseList = [];
  hasUsedList = [];
  expiredList = [];
}

export default {
  name: 'MyCoupons',
  components: {
    Tabs,
    CouponCard,
    Blank,
    CustomerServiceBtn
  },
  data() {
    return {
      curTab: 'waitUseList',
      // waitUseList--待使用列表
      // hasUsedList--已使用列表
      // expiredList--已过期列表
      tabsOptions: [
        {
          text: '待使用',
          key: 'waitUseList'
        },
        {
          text: '已使用',
          key: 'hasUsedList'
        },
        {
          text: '已过期',
          key: 'expiredList'
        }
      ],
      cardList: [],
      info: new CreateInfo(),
      showLoading: false,
      showPullRefreshLoading: false
    };
  },
  computed: {
    isDisabled() {
      return !(this.curTab === 'waitUseList');
    }
  },
  created() {
    this.toFindPurchasedRight();
  },
  methods: {
    handleTabClick(key) {
      this.curTab = key;
      this.cardList = [];
      setTimeout(() => {
        this.cardList = this.info[this.curTab] || [];
      }, 100);
    },
    toFindPurchasedRight() {
      const param = {
        purchasedRightType: '1',
        valid: '1'
      };
      this.showPullRefreshLoading = true;
      findPurchasedRight(param)
        .then((res) => {
          if (res) {
            this.info = res;
            this.handleTabClick(this.curTab);
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.showPullRefreshLoading = false;
          }, 500);
        });
    },
    toCharingCenterPage() {
      if (this.$browserEnv == 0) {
        wx.miniProgram.switchTab({
          url: '/pages/home/home'
        });
      } else {
        this.$parent.handleNavBarClick('CharingCenter');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.my-coupons-page {
  min-height: calc(100vh - 114px);
  background: #f7f7f7;
  box-sizing: border-box;

  .coupons {
    box-sizing: border-box;
    min-height: calc(100vh - 114px);
    padding: 16px 32px 0px 32px;
  }
  .coupons-blank {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    transform: translateY(20vh);

    .buy-coupon-btn {
      background: #fe7256;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      width: 320px;
      height: 90px;
      margin-top: 64px;
    }
  }
}
.h-bottom-nav {
  height: calc(98px + constant(safe-area-inset-bottom));
  height: calc(98px + env(safe-area-inset-bottom));
}
</style>
